import { FiTrash2, FiEdit2 } from "react-icons/fi";

const ItemCard = ({ item, onToggleActive, onDelete, onEdit }) => {
  const handleDelete = () => {
    const ok = window.confirm(
      `A je i sigurt që dëshiron ta fshish "${item.name}"?`
    );
    if (!ok) return;
    onDelete(item.id);
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-[#a6a6a6]/30 bg-white">
      <div className="h-32 sm:h-36 w-full bg-[#e0d8c3]/20">
        {item.imageUrl ? (
          <img
            src={item.imageUrl}
            alt={item.name}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-[#a6a6a6]">
            Pa foto
          </div>
        )}
      </div>

      <div className="p-3 sm:p-4">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 flex-1">
            <p className="font-semibold text-[#000000] truncate text-sm sm:text-base">
              {item.name}
            </p>
            {(item.shenime || item.description) && (
              <p className="mt-0.5 text-xs text-[#a6a6a6] line-clamp-2">
                {item.shenime || item.description}
              </p>
            )}
          </div>
          <div className="shrink-0 rounded-xl bg-[#e0d8c3]/40 px-2.5 py-1 text-sm font-semibold text-[#000000]">
            € {Number(item.price ?? 0).toFixed(2)}
          </div>
        </div>

        <div className="mt-3 sm:mt-4 flex flex-wrap items-center justify-between gap-2">
          <span
            className={`rounded-full px-2.5 py-1 text-xs font-medium ${
              item.isActive
                ? "bg-green-500/15 text-green-800"
                : "bg-[#a6a6a6]/20 text-[#a6a6a6]"
            }`}
          >
            {item.isActive ? "Aktive" : "Jo aktive"}
          </span>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => onEdit?.(item)}
              className="rounded-xl border border-[#a6a6a6]/50 bg-white px-3 py-2 min-h-[44px] text-xs text-[#000000] hover:bg-[#e0d8c3]/30 transition touch-manipulation flex items-center justify-center"
              title="Ndrysho produktin"
            >
              <FiEdit2 size={16} />
            </button>
            <button
              type="button"
              onClick={() => onToggleActive(item.id, !!item.isActive)}
              className="rounded-xl border border-[#a6a6a6]/50 bg-white px-3 py-2 min-h-[44px] text-xs text-[#000000] hover:bg-[#e0d8c3]/30 transition touch-manipulation flex items-center"
            >
              {item.isActive ? "Çaktivizo" : "Aktivizo"}
            </button>

            <button
              type="button"
              onClick={handleDelete}
              className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 min-h-[44px] text-xs text-red-600 hover:bg-red-100 transition touch-manipulation flex items-center justify-center"
              title="Fshij produktin"
            >
              <FiTrash2 size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
